module.exports = __webpack_public_path__ + "static/media/howwork-1.f015ff36.svg";